import { onScopeDispose, ref } from 'vue'

const online = ref(typeof navigator === 'undefined' ? true : navigator.onLine)
let listening = false

/** Отметка о связи от клиента API: сбой запроса или успешный ответ. */
export function reportConnectivity(value: boolean): void {
  online.value = value
}

/** Есть ли связь: события браузера плюс результат последнего запроса к API (ТЗ 14.1). */
export function useOnline() {
  if (!listening && typeof window !== 'undefined') {
    listening = true
    const on = () => (online.value = true)
    const off = () => (online.value = false)
    window.addEventListener('online', on)
    window.addEventListener('offline', off)
    onScopeDispose(() => {
      window.removeEventListener('online', on)
      window.removeEventListener('offline', off)
      listening = false
    })
  }
  return online
}
